import React, { ReactElement } from 'react';
import { Input, InputGroup } from '@chakra-ui/react';
import { SearchIcon } from 'assets/icons/v2';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const GroupFilterInput = ({ value, onChange, placeholder }: Props): ReactElement => {
  return (
    <InputGroup startElement={<SearchIcon color="icon.quaternary" boxSize="13.5px" />}>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || 'Gib den Namen des Kurses ein, um zu suchen...'}
        height="44px"
        borderRadius="10px"
        borderColor="border.accent"
        _placeholder={{ color: 'text.quaternary', textStyle: 'body.s.regular' }}
        textStyle="body.s.regular"
      />
    </InputGroup>
  );
};
